export default __webpack_public_path__ + "static/lead-ec10e2aadda451c5c957b39360c1c1d1.png";